/**
 * 重複登録エラー(判定用のため)
 */
export class DuplicateError extends Error {
  constructor(message) {
    super(message);
    this.name = "duplicate request";
  }
}


